import { render } from "./workflowlayoutcard-overview.vue?vue&type=template&id=715f260f"
import script from "./workflowlayoutcard-overview.vue?vue&type=script&lang=js"
export * from "./workflowlayoutcard-overview.vue?vue&type=script&lang=js"

import exportComponent from "/usr/lib/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__